export const ssoTexts = {
  idpEntityId: {
    LABEL: "Entity ID",
    HELPER_TEXT: " ",
    REQUIRED: "Idp entity id is required",
  },
  ssoUrl: {
    LABEL: "SSO URL",
    HELPER_TEXT: " ",
    REQUIRED: "SSO URL is required",
  },
  certificate: {
    LABEL: "Certificate",
    HELPER_TEXT: "Must start with “-----BEGIN CERTIFICATE-----”, and end with “-----END CERTIFICATE-----”",
    REQUIRED: "Certificate is required",
  },
  clientId: {
    LABEL: "Client ID",
    HELPER_TEXT: " ",
    REQUIRED: "Client ID is required",
  },
  issuerUrl: {
    LABEL: "Issuer URL",
    HELPER_TEXT: " ",
    REQUIRED: "Issuer URL is required",
  },
  clientSecret: {
    LABEL: "Client secret",
    HELPER_TEXT: " ",
    REQUIRED: "Client secret is required",
  },

  CERTIFICATE_START_WITH: "-----BEGIN CERTIFICATE-----",
  CERTIFICATE_END_WITH: "-----END CERTIFICATE-----",
  INVALID_URL: "URL is not valid",
  DESCRIPTION: (ssoType) => `Configure using the ${ssoType} protocol`,

  DIALOG_SELECT_TITLE: "SSO protocol change",
  DIALOG_SELECT_DESCRIPTION: (samlEnabled) =>
    `You are about to change from ${samlEnabled ? "SAML to OIDC" : "OIDC to SAML"}. Are you sure you want to do this?`,

  DIALOG_SAVE_CONFIG_TITLE: (type) => `${type.toUpperCase()} configuration`,
  DIALOG_SAVE_CONFIG_DESCRIPTION: (type) =>
    `You are about to create or change the ${type.toUpperCase()} configuration for your account.\n\nSSO will be automatically enabled when you press CONFIRM.`,
  CONFIGURE: "Configure",
  EDIT_CONFIGURATION: "Edit configuration",
  ENABLE_SSO: "Enable SSO",
  SECURITY: "Security",
  SSO_AUTHENTICATION: "Single sign-on",
  ERROR_MESSAGE: (type) =>
    `We were unable to configure and save your ${type.toUpperCase()} protocol. Please try again, or contact support`,
  SUCCESS_SNACKBAR_TEXT: (type) => `SSO protocol changed to ${type.toUpperCase()}`,
  FAILURE_SNACKBAR_TEXT: (type) => `Unable to switch to ${type.toUpperCase()}`,
};

export const ssoGroupsMappingText = {
  GROUPS_MAPPING_HEADER: "Group ID Mapping",
  GROUPS_MAPPING_DESCRIPTION:
    "Assign your SSO Group IDs to specific roles and organizations in the DoiT Console for non-admin users. When users match multiple groups, the topmost mapping takes priority and overrides those below.",
  GROUPS_ATTR_KEY_LABEL: "Groups attribute key",
  GROUPS_ATTR_KEY_DESCRIPTION: "The key passed from your SSO provider to describe the user groups upon sign in.",
  GROUP_ID_HEADER: "Group ID",
  GROUP_ID_TOOLTIP: "Group ID is used by your SSO provider to match users to the correct roles and permissions.",
  GROUP_ID_LABEL: "Group ID",
  GROUP_ID_DEFAULT: "* (Default)",
  GROUP_ID_FORMAT_ERROR: "Group ID can only contain letters, numbers, underscores, and hyphens",
  GROUP_ID_UNIQUE_ERROR: "Group ID must be unique",
  ROLE_ID_HEADER: "DoiT Role",
  ROLE_ID_LABEL: "Role",
  ROLE_ID_DEFAULT: "default",
  ROLE_VALUE_DEFAULT: "Power user (Default)",
  ORGANIZATION_ID_HEADER: "Organization",
  ORGANIZATION_ID_LABEL: "Organization",
  ORGANIZATION_ID_TOOLTIP: "Default mapping is linked to your root organization.",
  BUTTON_ADD_MAPPING: "Add mapping",
  BUTTON_SAVE: "Save",
  BUTTON_SAVING: "Saving...",
  BUTTON_CANCEL: "Cancel",
  MSG_ERR_DELETING: "Error deleting mapping",
  MSG_INFO_SAVED: "SSO group mappings saved successfully",
  MSG_ERR_NOT_SAVED: (error) => `Failed to save SSO group mappings: ${error}`,
};
